import styled from 'styled-components';

const Style = styled.div`
  width: 100%;
  padding: var(--size-lg) 30px;
  min-height: 400px;
`;

export default Style;
